<ng-template #skeleton>
  <app-pharmacy-card-skeleton></app-pharmacy-card-skeleton>
</ng-template>

<div (click)="onSelectItem(actions)"
     *ngIf="!showSkeleton && pharmacy; else skeleton"
     class="app-card-box"
     [class.w-100]="fullWidth"
     [ngClass]="pharmacy?.distance > 0 ? 'custom-height': 'h-100'">

  <div class="d-flex gap-4 ion-justify-content-between"
       *ngIf="vediTutte; else cardContent">
    <div class="ts-h4">Vedi tutte <br>le farmacie</div>
    <div>
      <ion-icon style="font-size: 30px" name="arrow-forward-circle-outline"></ion-icon>
    </div>
  </div>

  <ng-template #cardContent>
    <div style="height: 40px;"
         class="d-flex ion-align-items-center ion-justify-content-between">

      <div class="ion-text-capitalize text-ellipsis pharmacy-name ts-body-bold">{{ pharmacy?.name }}</div>


    </div>

    <div>
      <div class="ts-small text-neutral-600">{{ pharmacy?.address }}</div>
      <div class="ts-small pt-xxs text-neutral-600">{{ pharmacy?.phoneNumber }}</div>
    </div>

    <div class="d-flex ion-justify-content-between ion-align-items-center">

      <app-distance-place-footer *ngIf="pharmacy?.distance > 0"
                                 [distance]="pharmacy.distance"
                                 class="d-block w-100"
                                 [distanceLabel]="pharmacy.distanceLabel"></app-distance-place-footer>

      <div [class.text-green-500]="pharmacy.open"
           [class.text-magenta-500]="!pharmacy.open"
           class="text-green-500 ion-text-right ts-small-bold w-100">{{ pharmacy.statusLabel }}
      </div>

    </div>

  </ng-template>


</div>
<app-pharmacy-actions #actions
                      [pharmacy]="pharmacy"></app-pharmacy-actions>
